import React from "react";
import { hexToCSSFilter } from "hex-to-css-filter";
import imageMadeWithPuck from "images/ic_made_with_puck.png";
import styled from "styled-components";

const Container = styled.div`
  border-radius: 281.335px;

  &:hover {
    ${(props) =>
      props.$hoverBackgroundColor &&
      `background-color: ${props.$hoverBackgroundColor};`}
  }
`;

const Image = styled.img`
  display: block;
  ${(props) =>
    props.$color &&
    `filter: brightness(0) saturate(100%) ${
      hexToCSSFilter(props.$color).filter
    };`}
`;

const MadeWithPuckBadge = ({ color, hoverBackgroundColor, onClick }) => {
  return (
    <a href="https://www.careerpuck.com" onClick={onClick}>
      <Container $hoverBackgroundColor={hoverBackgroundColor}>
        <Image
          src={imageMadeWithPuck}
          alt="Made with Puck"
          width={213.45}
          height={55.34}
          $color={color}
        />
      </Container>
    </a>
  );
};

export default MadeWithPuckBadge;
